import { createAction, props } from "@ngrx/store";
import IUser from "@skills-app/models/user";

const prefix = "[User Search Bar]";

export const addUserToSearch = createAction(
  `${prefix} Add User To Search`,
  props<{ user: IUser }>(),
);
export const removeUserFromSearch = createAction(
  `${prefix} Remove User From Search`,
  props<{ user: IUser }>(),
);
export const clearSelectedUsers = createAction(
  `${prefix} Clear Selected Users`,
);
export const setUsersToSearch = createAction(
  `${prefix} Set Users To Search`,
  props<{ users: IUser[] }>(),
);
